import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-marketing",
  "use": "icon-marketing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-marketing\"><defs><style type=\"text/css\"></style></defs><path d=\"M793.8 932.3c-12.7 0-25.4-3.4-37-10.3L335.3 670.4c-5.7-3.4-12.2-5.2-18.8-5.2h-86.3c-39.8 0-72.2-32.4-72.2-72.2V431.6c0-39.8 32.4-72.2 72.2-72.2h86.3c6.6 0 13.1-1.8 18.8-5.2l421.6-251.6c22.6-13.5 49.7-13.8 72.6-0.8 22.9 13 36.5 36.5 36.5 62.8v508.2c0 9.8-7.9 17.7-17.7 17.7-9.8 0-17.7-7.9-17.7-17.7V164.6c0-13.4-6.9-25.3-18.6-31.9-11.6-6.6-25.4-6.4-36.9 0.4L353.5 384.7c-11.2 6.7-24 10.2-37 10.2h-86.3c-20.2 0-36.7 16.5-36.7 36.7V593c0 20.2 16.5 36.7 36.7 36.7h86.3c13 0 25.8 3.5 37 10.2L775 891.5c11.5 6.8 25.3 7 36.9 0.4 11.6-6.6 18.6-18.5 18.6-31.9v-38.1c0-9.8 7.9-17.7 17.7-17.7 9.8 0 17.7 7.9 17.7 17.7V860c0 26.3-13.7 49.8-36.5 62.8-11.1 6.3-23.4 9.5-35.6 9.5z\" p-id=\"3673\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/marketing.svg
// module id = mkJ9
// module chunks = 118